import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
var determineLanguageDifferences = function determineLanguageDifferences(preferredLanguages, formValues) {
  var _context, _context2, _context3, _context4, _context5, _context6;
  // Separate existing spoken and written languages
  var existingSpokenLanguages = _filterInstanceProperty(preferredLanguages).call(preferredLanguages, function (item) {
    return item.record_language_type === 'spoken';
  });
  var existingWrittenLanguages = _filterInstanceProperty(preferredLanguages).call(preferredLanguages, function (item) {
    return item.record_language_type === 'written';
  });

  // Extract language_ids for comparison
  var existingSpokenLanguageIds = _mapInstanceProperty(existingSpokenLanguages).call(existingSpokenLanguages, function (item) {
    return item.language.id;
  });
  var existingWrittenLanguageIds = _mapInstanceProperty(existingWrittenLanguages).call(existingWrittenLanguages, function (item) {
    return item.language.id;
  });

  // Languages selected by the user
  var finalSpokenLanguages = formValues.preferred_spoken_languages;
  var finalWrittenLanguages = formValues.preferred_written_languages;

  // Identify record_languages to add
  // Get the languages IDs from the values that are not present in the existing spoken and written languages list
  var languagesToAdd = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_mapInstanceProperty(_context2 = _filterInstanceProperty(finalSpokenLanguages).call(finalSpokenLanguages, function (id) {
    return !_includesInstanceProperty(existingSpokenLanguageIds).call(existingSpokenLanguageIds, id);
  })).call(_context2, function (id) {
    return {
      language_id: id,
      record_language_type: 'spoken'
    };
  })), _toConsumableArray(_mapInstanceProperty(_context3 = _filterInstanceProperty(finalWrittenLanguages).call(finalWrittenLanguages, function (id) {
    return !_includesInstanceProperty(existingWrittenLanguageIds).call(existingWrittenLanguageIds, id);
  })).call(_context3, function (id) {
    return {
      language_id: id,
      record_language_type: 'written'
    };
  })));

  // Get the IDs from the records that belongs to the existing spoken and written languages list
  // but are not present in the final spoken and written languages list
  var languagesToRemove = _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(_mapInstanceProperty(_context5 = _filterInstanceProperty(existingSpokenLanguages).call(existingSpokenLanguages, function (item) {
    return !_includesInstanceProperty(finalSpokenLanguages).call(finalSpokenLanguages, item.language.id);
  })).call(_context5, function (item) {
    return {
      id: item.id
    };
  })), _toConsumableArray(_mapInstanceProperty(_context6 = _filterInstanceProperty(existingWrittenLanguages).call(existingWrittenLanguages, function (item) {
    return !_includesInstanceProperty(finalWrittenLanguages).call(finalWrittenLanguages, item.language.id);
  })).call(_context6, function (item) {
    return {
      id: item.id
    };
  })));
  return {
    languagesToAdd: languagesToAdd,
    languagesToRemove: languagesToRemove
  };
};
export default determineLanguageDifferences;
//# sourceMappingURL=determineLanguageDifferences.js.map